import { createSelector } from '@reduxjs/toolkit'
import { ActiveUserJourney, UserJourneyState } from './reducer'
import { useAppSelector } from '../hooks'
import { CheckoutAppSelector } from '../store'

const userJourneySelector: CheckoutAppSelector<UserJourneyState> = (state) => state.userJourney

export const activeUserJourneySelector = createSelector(userJourneySelector, (state) => state.active)
export const userJourneyIdSelector = createSelector(userJourneySelector, (state) => state.active?.journeyId)

export const useActiveUserJourney = (): ActiveUserJourney | undefined => useAppSelector(activeUserJourneySelector)
export const useUserJourneyId = (): string | undefined => useAppSelector(userJourneyIdSelector)
